const wwPointsPopupTrigger = document.querySelector('.ww-points-popup__trigger');
const wwPointsPopup = document.querySelector('.ww-points-modal__wrapper');
wwPointsPopupTrigger?.addEventListener('click', () => {
  wwPointsPopup?.classList.add('show');
  document.body.style.overflow = 'hidden';
})

document.addEventListener('click', (event) => {
  if((!event.target.closest('.ww-points-popup__trigger') && !event.target.closest('.ww-points-modal__wrapper')) || event.target.closest('.ww-points-popup__close')) {
    wwPointsPopup?.classList.remove('show');
    document.body.style.overflow = '';
  }
  if (!event.target.closest('.ww-points-modal-content') && event.target.closest('.ww-points-modal__wrapper')) {
    wwPointsPopup?.classList.add('scale-effect');

    // remove after 1 second to reset
    setTimeout(() => {
      wwPointsPopup?.classList.remove('scale-effect');
    }, 300);
  }
});